<template>
  <div>
    <BaseBreadcrumb
      v-if="getBreadcrumb"
      class="mt-4 container"
      :breadcrumb="getBreadcrumb"
    />
    <div class="our-totality">
      <div v-for="item in ourTotality" class="our-totality__items">
        <div>
          <client-only>
            <p class="title">
              {{ item.title }}
            </p>
            <p class="text" v-html="item.text" />
          </client-only>
        </div>
        <div>
          <img
            :data-src="item.image"
            width="530"
            height="350"
            class="lazyload w-full lg:w-auto"
            :alt="item.title"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseBreadcrumb from '@design-system/base/breadcrumb/breadcrumb-pages'

import { mapGetters } from 'vuex'
import staticData from './static-data'
export default {
  name: 'AboutUsOurTotality',
  components: { BaseBreadcrumb },
  data () {
    return {
      ...staticData
    }
  },
  computed: {
    ...mapGetters('global', ['getBreadcrumb'])
  }
}
</script>

<style lang="scss">
.our-totality {
  @apply container mt-4 lg:mt-6;
  &__items {
    @apply flex flex-col flex-col-reverse lg:flex-row items-center lg:space-x-8 mb-8 lg:mb-16;
    .title {
      @apply text__headline-3-xs--bold lg:text__headline-3-md--bold mt-4 lg:mt-0;
    }
    .text {
      @apply text__body-1-xs--regular lg:text__body-1-md--regular mt-3 lg:mt-4;
      .subtitle {
        @apply text__headline-3-xs--semibold text__headline-5-md--bold mt-4 mb-3;
      }
      .list {
        @apply list-disc space-y-4 pl-4;
      }
    }
    &:nth-of-type(2n) {
      @apply flex-col flex-col-reverse lg:flex-row-reverse lg:space-x-reverse;
    }
    > div {
      @apply w-full lg:w-1/2;
    }
  }
}
</style>
